import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import styles from "./../Hostels/houses.module.css";
import styless from './style.module.css';
import { FaStarOfLife } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Fetchindividualblogsurl } from './../Utils/urls';
import { getsessionuser, getsessionhouse } from './../Utils/sessions';
import Universalheader from "../Headers/universalheader";
import { Modal } from "@mui/material";
import Editblog from "./editblog";



let color = primarycolor;
let type = "spokes";


const Fetchmyblogs = () => {

    const navigate = useNavigate();
    const location = useLocation()


    const sessionuser = getsessionuser();
    const landlorduser = getsessionhouse();
    const [user, setuser] = useState(sessionuser);

    const [progress, setprogress] = useState(true);
    const [blogs, setblogs] = useState([]);
    const [error, seterror] = useState('');

    const [bloginplay, setbloginplay] = useState('');

    //modals
    const [showaddview, setshowaddview] = useState(false);

    //message from previous page
    const messagef = location.state?.message;


    useEffect(() => {
        getmyblogs();
        if (messagef) {
            setshowaddview(true)
        }
    }, []);

    const getmyblogs = () => {
        setprogress(true)
        setblogs([])
        axios.post(Fetchindividualblogsurl, {
            id: user?.id,
        }).then(response => {
            setprogress(false)
            if (!response.data.message) {
                setblogs(response.data)
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setprogress(false)
            seterror("Sorry an error occurred,try again later");

        });
    }


    const onsuccesspost = () => {
        setshowaddview(false)
        getmyblogs()
    }

    return (
        <div className={styles.container}>
            <Modal
                open={showaddview}
                onClose={() => setshowaddview(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Editblog blog={bloginplay} onsuccesspost={onsuccesspost} />
            </Modal>

            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader />
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate('/nav/eaziblog')} style={{ cursor: "pointer" }}>blogs  /</a>
                    <a style={{ cursor: "pointer" }}>myblogs</a>
                </div>
                <div className={styles.bodydiv}>
                    <div className={styles.housedetailsdiv}>
                        {error &&
                            <div className={styless.errordiv2}><div style={{ color: "red", fontSize: 10 }}>{error}</div>
                                <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate("/nav/eaziblog")}>Click to post blog</a>
                            </div>
                        }
                        {!progress && <div className={styless.propertydivwhole}>
                            {
                                blogs.map((val, key) => {
                                    return (
                                        <div key={key} className={styless.propertydiv} onClick={() => {
                                            setbloginplay(val)
                                            setshowaddview(true)
                                        }}>
                                            <img src={val.blogurl} className={styless.propertydivimage} />
                                            <div className={styless.housedetailsdiv}>
                                                <div style={{ fontWeight: "bold" }}>{val.title}</div>
                                                <div>{val.clicks} clicks</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>}
                        {progress &&
                            <div>
                                <ReactLoading type={type} color={color} height={25} width={20} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Fetchmyblogs;

